import React from 'react';
import type { Nullable } from 'corgi-types';

import { Flex } from 'common/components/Flex';
import { HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { ReclamationSolution } from 'common/types/reclamation';
import EditButton from '../EditButton';
import SectionContainer from './SectionContainer';
import Subtitle from './Subtitle';

export interface EditSolutionButtonProps {
  isDisabled: boolean;
  onClick: (itemId: string) => void;
  solution?: Nullable<ReclamationSolution>;
}

const EditSolutionButton = ({ solution, isDisabled, onClick }: EditSolutionButtonProps) => {
  const { r, t } = useLocalization();

  return (
    <Flex justifyContent="space-between" alignItems="flex-start">
      <SectionContainer>
        <HeadlineH8 as="h2" data-testid="solution">
          {solution ? solution.title : t('h24_click_here_to_provide_solution')}
        </HeadlineH8>
        {solution && !!solution.subTitle && (
          <Subtitle data-testid="solution-notice">{solution.subTitle}</Subtitle>
        )}
      </SectionContainer>
      <EditButton
        dataTestId="edit-solution-button"
        ariaLabel={
          solution
            ? `${r.t('h24_edit_solution', {
                solution: solution.title,
              })}`
            : `${t('h24_click_here_to_provide_solution')}`
        }
        isDisabled={isDisabled}
        onClick={onClick}
      />
    </Flex>
  );
};

export default EditSolutionButton;
